// Copyright (c) StrangeBee 2024

import { CaseContent } from '@Organisms/Timeline/Cards/Case/CaseContent';
import { AlertContent } from '@Organisms/Timeline/Cards/Alert/AlertContent';
import { ObservableContent } from '@Organisms/Timeline/Cards/Observable/ObservableContent';
import { ProcedureContent } from '@Organisms/Timeline/Cards/Procedure/ProcedureContent';
import { TaskContent } from '@Organisms/Timeline/Cards/Task/TaskContent';
import { LogContent } from '@Organisms/Timeline/Cards/Log/LogContent';
import { CustomEventContent } from '@Organisms/Timeline/Cards/CustomEvent/CustomEventContent';
import { ReactElement, JSXElementConstructor } from 'react';
import { DisplayEventProps } from '../DisplayEvent';

type CardType = (props: DisplayEventProps) => ReactElement<any, string | JSXElementConstructor<any>> | null;

export const libCards: Record<string, CardType> = {
    Case: CaseContent,
    Alert: AlertContent,
    Procedure: ProcedureContent,
    Observable: ObservableContent,
    Task: TaskContent,
    Log: LogContent,
    CustomEvent: CustomEventContent,
};
